import service from './service';
// import { API_URL } from '../config/config';

export const getAddressConfigApi = () => {
  return service.extGet(`https://www.getpostman.com/collections/eb805bc03da6582f2f33`);
};
